import React from 'react'
import { connectApp } from '../../reducers';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../theme/ThemeContext';
import { Suspense } from 'react';
import { ISProgress } from "../../components/ISProgress";
import logo from '../images/logo-saladillo.svg'
import logoDark from '../images/logo-saladillo-dark.png'
import { CssBaseline, Stack, ThemeProvider } from '@mui/material'
import { Typography, Box, Link } from '@mui/material'


const Terms: React.FC = () => {
  const { theme, darkModeEnabled } = useThemeContext()
  const { t } = useTranslation(['about', 'login']);

  return (
    <Suspense fallback={<ISProgress />}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Stack style={{ display: "flex", flexDirection: "column", minHeight: "500px", justifyContent: "space-evenly" }}>

          <Typography align="center" variant="h4" marginTop="20px">
            <img alt={"Industrias Saladillo"} src={darkModeEnabled ? logoDark : logo} />
          </Typography>

          <Box display="flex" flexDirection="column">
            <Typography align="center" color="secondary" variant="h4">
              {t('portal', { ns: 'login' })}
            </Typography>
            <Typography align="center" fontWeight='bold' variant="h6">
              {t('terms', { ns: 'login' })}
            </Typography>
          </Box>
          <Box style={{ display: "flex", flexDirection: "row", justifyContent: 'center' }}>
            <Box style={{ display: "flex", flexDirection: "column", margin: '50px', padding: '30px', maxWidth: '1000px' }}>
              <Typography fontWeight='bold' sx={{ textDecoration: 'underline' }} variant="h6">
                {t('terms.termsTitle')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('terms.1')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('terms.1text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('terms.2')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('terms.2text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('terms.3')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('terms.3text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('terms.4')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('terms.4text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('terms.5')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('terms.5text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('terms.6')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('terms.6text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' sx={{ textDecoration: 'underline' }} variant="h6">
                {t('privacy.privacyTitle')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('privacy.1')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('privacy.1text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('privacy.2')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('privacy.2text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography variant="body1" marginLeft='10px'>
                {t('privacy.2text2')}
              </Typography>
              <Typography variant="body1" marginLeft='10px'>
                {t('privacy.2text3')}
              </Typography>
              <Typography variant="body1" marginLeft='10px'>
                {t('privacy.2text4')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('privacy.3')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('privacy.3text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('privacy.4')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('privacy.4text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('privacy.5')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('privacy.5text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('privacy.6')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('privacy.6text')}
              </Typography>
              <Typography>&nbsp;</Typography>
              <Typography fontWeight='bold' variant="body1">
                {t('contact')}
              </Typography>
              <Typography variant="body1" textAlign='justify'>
                {t('contactText')}
                <Link href={`mailto:${t('contactEmail')}`} underline='hover' target="_blank">{t('contactEmail')}</Link>
                &nbsp;{t('or')}&nbsp;
                <Link href={`tel:${t('contactPhone')}`} underline='hover' target="_blank">{t('contactPhone')}</Link>
                .
              </Typography>
              <Typography>&nbsp;</Typography>
            </Box>
          </Box>
          <Link textAlign="center" color="secondary" href={`login`} underline='hover' target="_blank">
            {t("login", { ns: 'login' })}
          </Link>
          <Typography>&nbsp;</Typography>
          <Typography>&nbsp;</Typography>
        </Stack>
      </ThemeProvider>
    </Suspense>
  )
}

export default connectApp()(Terms)
